const types = {
  SET_DATES: 'SET_DATES',
  SET_DEFAULT_DATES: 'SET_DEFAULT_DATES',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/calendar/mutations-types.js